"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hooks_1 = require("../../hooks");
exports.Query = function (_a) {
    var action = _a.action, children = _a.children, _b = _a.initFetch, initFetch = _b === void 0 ? true : _b;
    var response = hooks_1.useQuery(action, initFetch);
    return children(response);
};
